import Vue from 'vue'
import App from './App.vue'
import './_plugins/registerServiceWorker'
import router from './_router'
import store from './_store'
import vuetify from './_plugins/vuetify'
import '@/_styles/main.scss'
import draggable from "vuedraggable";
import { Container, Draggable } from "vue-smooth-dnd";
import VueClipboard from 'vue-clipboard2'
import i18n from '@/_plugins/i18n'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.config.productionTip = false
Vue.component('container',Container);
Vue.component('draggable',Draggable);
Vue.use(VueClipboard);

//Toast options
const options = {
  position: 'top-center',
  timeout: 10000
  // You can set your default options here
}
Vue.use(Toast, options)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
